import React from 'react';
import { useLoaderData } from 'react-router-dom';
import AnimationScreen from '../components/AnimationScreen';
import ProgressBar from '../components/ProgressBar';
import NavigationBar from '../components/NavigationBar';
import ResourceList from '../components/ResourceList';
import AdditionalHelp from '../components/AdditionalHelp';
import CardLink from '../components/CardLink';
import { PageData } from '../types/types';

const Results: React.FC = () => {
	const { title, progress, prev, content } = useLoaderData() as PageData;
	let containerClass = '';

	if ( content.blockLinksOnly ) {
		containerClass = 'c-guided-help__support--grid';
	}

	return (
		<AnimationScreen>
			<ProgressBar progress={progress} />
			<h3>{title}</h3>
			<div className={`c-guided-help__support ${ containerClass }`}>
				{content.blockLinks && <ResourceList resources={content.blockLinks} />}

				{! content.blockLinksOnly && content.cardLink && (
					<CardLink link={content.cardLink} />
				)}

				{! content.blockLinksOnly && content.additionalLinks && (
					<AdditionalHelp links={content.additionalLinks} />
				)}
			</div>
			<NavigationBar prev={prev} last={true} />
		</AnimationScreen>
	);
};

export default Results;
